import { Alert, Box } from '@mui/material';
import { useField } from 'formik';
import { useTranslation } from 'react-i18next';

import { FormikCheckbox } from 'components';
import { TranslationNamespace } from 'i18n';

type Props = {
  fieldPath: string;
};

export const IgnoreWebhookField: React.FC<Props> = ({ fieldPath }) => {
  const { t } = useTranslation(TranslationNamespace.Admin, {
    keyPrefix: 'pages.p2p_providers',
  });

  const [field] = useField<boolean>(`${fieldPath}.ignoreWebhook`);

  return (
    <Box>
      <FormikCheckbox
        label={t('fields.ignore_webhook')}
        name={`${fieldPath}.ignoreWebhook`}
      />
      {field.value && (
        <Alert severity="warning">{t('fields.ignore_webhook_warning')}</Alert>
      )}
    </Box>
  );
};
